import { createFileRoute } from '@tanstack/react-router'
import ImovelDetailPage from '@/pages/imoveis/imovel-detail'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

// Rota index para /dashboard/$dashboardId/imoveis/$imovelId
// Renderizada quando acessar diretamente /dashboard/$dashboardId/imoveis/$imovelId
// Sem rota filha ativa
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/imoveis/$imovelId/',
)({
  component: function ImovelDetailRoute() {
    const { dashboardId, imovelId } = Route.useParams()
    return (
      <RequireModule module={MODULES.IMOVEIS} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.VIEW_IMOB_DATA}>
          <ImovelDetailPage imovelId={imovelId} dashboardId={dashboardId} />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
